import { render, staticRenderFns } from "./ManageComponent.vue?vue&type=template&id=9c8cb2f0"
import script from "./ManageComponent.vue?vue&type=script&lang=js"
export * from "./ManageComponent.vue?vue&type=script&lang=js"
import style0 from "./ManageComponent.vue?vue&type=style&index=0&id=9c8cb2f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports